<div class="flex flex-col gap-8">
  <span class="text-[18px] font-bold">Cuestiones Tecnicas</span>

  <div class="flex flex-col gap-8">
    <div class="flex flex-col gap-4">
      <span class="text-[16px] font-semibold">Alojamiento</span>

      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('infrastructure')"
          (change)="reviewFields.toggleField('infrastructure')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Infraestructura</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('infrastructure')"
              class="-mt-2"
              [description]="previousReviewText('infrastructure')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">
            {{ technicalIssuesData?.infrastructure || '-' }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <span class="text-[16px] font-semibold">Integracion</span>

      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('integrationMode')"
          (change)="reviewFields.toggleField('integrationMode')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Modo de integracion con la plataforma corporativa</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('integrationMode')"
              class="-mt-2"
              [description]="previousReviewText('integrationMode')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">
            {{ technicalIssuesData?.integrationMode || '-' }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <span class="text-[16px] font-semibold">Datos de entrenamiento</span>

      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('dataSource')"
          (change)="reviewFields.toggleField('dataSource')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Origen de los datos</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('dataSource')"
              class="-mt-2"
              [description]="previousReviewText('dataSource')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">
            {{ technicalIssuesData?.dataSource || '-' }}
          </span>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('dataCategory')"
            (change)="reviewFields.toggleField('dataCategory')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Tipo de datos</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('dataCategory')"
                class="-mt-2"
                [description]="previousReviewText('dataCategory')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular whitespace-pre-line">
              {{ technicalIssuesData?.dataCategory || '-' }}
            </span>
          </div>
        </div>

        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('qualityAccreditation')"
            (change)="reviewFields.toggleField('qualityAccreditation')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Acreditacion de la calidad de los datos con CSV</span>
              <app-tooltip
                *ngIf="
                  reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('qualityAccreditation')
                "
                class="-mt-2"
                [description]="previousReviewText('qualityAccreditation')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular whitespace-pre-line">
              {{ technicalIssuesData?.qualityAccreditation || '-' }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('inputDataSource')"
          (change)="reviewFields.toggleField('inputDataSource')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Origen de la fuente de datos en tiempo real</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('inputDataSource')"
              class="-mt-2"
              [description]="previousReviewText('inputDataSource')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">
            {{ technicalIssuesData?.inputDataSource || '-' }}
          </span>
        </div>
      </div>

      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('timePeriod')"
          (change)="reviewFields.toggleField('timePeriod')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Periodo temporal cubierto</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('timePeriod')"
              class="-mt-2"
              [description]="previousReviewText('timePeriod')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">
            {{ technicalIssuesData?.timePeriod || '-' }}
          </span>
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('updateCheck')"
            (change)="reviewFields.toggleField('updateCheck')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Frecuencia y politica de actualizacion</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('updateCheck')"
                class="-mt-2"
                [description]="previousReviewText('updateCheck')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular">
              {{ technicalIssuesData?.updateCheck ? 'Si' : 'No' }}
            </span>
          </div>
        </div>

        <div
          *ngIf="technicalIssuesData?.updateCheck"
          class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('aiSystemUpdate')"
            (change)="reviewFields.toggleField('aiSystemUpdate')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Descripcion</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('aiSystemUpdate')"
                class="-mt-2"
                [description]="previousReviewText('aiSystemUpdate')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular whitespace-pre-line">
              {{ technicalIssuesData?.aiSystemUpdate || '-' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <span class="text-[16px] font-semibold">Codigo</span>

      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('sourceCode')"
          (change)="reviewFields.toggleField('sourceCode')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Enlace al codigo fuente</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('sourceCode')"
              class="-mt-2"
              [description]="previousReviewText('sourceCode')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">
            {{ technicalIssuesData?.sourceCode || '-' }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <span class="text-[16px] font-semibold">Operacion</span>

      <div class="flex flex-col gap-4">
        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('latencyCheck')"
            (change)="reviewFields.toggleField('latencyCheck')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Latencia y rendimiento verificados</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('latencyCheck')"
                class="-mt-2"
                [description]="previousReviewText('latencyCheck')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular">
              {{ technicalIssuesData?.latencyCheck ? 'Si' : 'No' }}
            </span>
          </div>
        </div>

        <div
          *ngIf="technicalIssuesData?.latencyCheck"
          class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('latencyPerformance')"
            (change)="reviewFields.toggleField('latencyPerformance')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Descripcion</span>
              <app-tooltip
                *ngIf="
                  reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('latencyPerformance')
                "
                class="-mt-2"
                [description]="previousReviewText('latencyPerformance')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular whitespace-pre-line">
              {{ technicalIssuesData?.latencyPerformance || '-' }}
            </span>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-8">
          <div class="flex gap-3 items-start">
            <input
              *ngIf="reviewMode && !readonlyReview"
              type="checkbox"
              class="mt-1"
              [checked]="reviewFields.isFieldMarked('scalabilityCheck')"
              (change)="reviewFields.toggleField('scalabilityCheck')" />
            <div class="flex flex-col gap-2">
              <div class="flex items-start gap-2">
                <span class="text-[14px] text-neutral-dark">Escalabilidad documentada</span>
                <app-tooltip
                  *ngIf="
                    reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('scalabilityCheck')
                  "
                  class="-mt-2"
                  [description]="previousReviewText('scalabilityCheck')"
                  tipeIcon="info"></app-tooltip>
              </div>
              <span class="text-[16px] font-regular">
                {{ technicalIssuesData?.scalabilityCheck ? 'Si' : 'No' }}
              </span>
            </div>
          </div>

          <div
            *ngIf="technicalIssuesData?.scalabilityCheck"
            class="flex gap-3 items-start">
            <input
              *ngIf="reviewMode && !readonlyReview"
              type="checkbox"
              class="mt-1"
              [checked]="reviewFields.isFieldMarked('csvScalability')"
              (change)="reviewFields.toggleField('csvScalability')" />
            <div class="flex flex-col gap-2">
              <div class="flex items-start gap-2">
                <span class="text-[14px] text-neutral-dark">Codigo identificador del documento</span>
                <app-tooltip
                  *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('csvScalability')"
                  class="-mt-2"
                  [description]="previousReviewText('csvScalability')"
                  tipeIcon="info"></app-tooltip>
              </div>
              <span class="text-[16px] font-regular whitespace-pre-line">
                {{ technicalIssuesData?.csvScalability || '-' }}
              </span>
            </div>
          </div>

          <div class="flex gap-3 items-start">
            <input
              *ngIf="reviewMode && !readonlyReview"
              type="checkbox"
              class="mt-1"
              [checked]="reviewFields.isFieldMarked('contingencyPlanCheck')"
              (change)="reviewFields.toggleField('contingencyPlanCheck')" />
            <div class="flex flex-col gap-2">
              <div class="flex items-start gap-2">
                <span class="text-[14px] text-neutral-dark">Plan de contingencia y desactivacion</span>
                <app-tooltip
                  *ngIf="
                    reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('contingencyPlanCheck')
                  "
                  class="-mt-2"
                  [description]="previousReviewText('contingencyPlanCheck')"
                  tipeIcon="info"></app-tooltip>
              </div>
              <span class="text-[16px] font-regular">
                {{ technicalIssuesData?.contingencyPlanCheck ? 'Si' : 'No' }}
              </span>
            </div>
          </div>

          <div
            *ngIf="technicalIssuesData?.contingencyPlanCheck"
            class="flex gap-3 items-start">
            <input
              *ngIf="reviewMode && !readonlyReview"
              type="checkbox"
              class="mt-1"
              [checked]="reviewFields.isFieldMarked('csvContingencyPlan')"
              (change)="reviewFields.toggleField('csvContingencyPlan')" />
            <div class="flex flex-col gap-2">
              <div class="flex items-start gap-2">
                <span class="text-[14px] text-neutral-dark">Codigo identificador del documento</span>
                <app-tooltip
                  *ngIf="
                    reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('csvContingencyPlan')
                  "
                  class="-mt-2"
                  [description]="previousReviewText('csvContingencyPlan')"
                  tipeIcon="info"></app-tooltip>
              </div>
              <span class="text-[16px] font-regular whitespace-pre-line">
                {{ technicalIssuesData?.csvContingencyPlan || '-' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <span class="text-[16px] font-semibold">Seguridad</span>

      <div class="flex flex-col gap-4">
        <div class="grid grid-cols-2 gap-6">
          <div class="flex gap-3 items-start">
            <input
              *ngIf="reviewMode && !readonlyReview"
              type="checkbox"
              class="mt-1"
              [checked]="reviewFields.isFieldMarked('cybersecurityCheck')"
              (change)="reviewFields.toggleField('cybersecurityCheck')" />
            <div class="flex flex-col gap-2">
              <div class="flex items-start gap-2">
                <span class="text-[14px] text-neutral-dark">Ciberseguridad integrada</span>
                <app-tooltip
                  *ngIf="
                    reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('cybersecurityCheck')
                  "
                  class="-mt-2"
                  [description]="previousReviewText('cybersecurityCheck')"
                  tipeIcon="info"></app-tooltip>
              </div>
              <span class="text-[16px] font-regular">
                {{ technicalIssuesData?.cybersecurityCheck ? 'Si' : 'No' }}
              </span>
            </div>
          </div>

          <div
            *ngIf="technicalIssuesData?.cybersecurityCheck"
            class="flex gap-3 items-start">
            <input
              *ngIf="reviewMode && !readonlyReview"
              type="checkbox"
              class="mt-1"
              [checked]="reviewFields.isFieldMarked('csvCybersecurity')"
              (change)="reviewFields.toggleField('csvCybersecurity')" />
            <div class="flex flex-col gap-2">
              <div class="flex items-start gap-2">
                <span class="text-[14px] text-neutral-dark">Codigo identificador del documento</span>
                <app-tooltip
                  *ngIf="
                    reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('csvCybersecurity')
                  "
                  class="-mt-2"
                  [description]="previousReviewText('csvCybersecurity')"
                  tipeIcon="info"></app-tooltip>
              </div>
              <span class="text-[16px] font-regular whitespace-pre-line">
                {{ technicalIssuesData?.csvCybersecurity || '-' }}
              </span>
            </div>
          </div>

          <div
            *ngIf="technicalIssuesData?.cybersecurityCheck"
            class="flex gap-3 items-start">
            <input
              *ngIf="reviewMode && !readonlyReview"
              type="checkbox"
              class="mt-1"
              [checked]="reviewFields.isFieldMarked('cybersecurity')"
              (change)="reviewFields.toggleField('cybersecurity')" />
            <div class="flex flex-col gap-2">
              <div class="flex items-start gap-2">
                <span class="text-[14px] text-neutral-dark">Descripcion</span>
                <app-tooltip
                  *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('cybersecurity')"
                  class="-mt-2"
                  [description]="previousReviewText('cybersecurity')"
                  tipeIcon="info"></app-tooltip>
              </div>
              <span class="text-[16px] font-regular whitespace-pre-line">
                {{ technicalIssuesData?.cybersecurity || '-' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('accessControlCheck')"
            (change)="reviewFields.toggleField('accessControlCheck')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Control de acceso y autenticacion</span>
              <app-tooltip
                *ngIf="
                  reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('accessControlCheck')
                "
                class="-mt-2"
                [description]="previousReviewText('accessControlCheck')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular">
              {{ technicalIssuesData?.accessControlCheck ? 'Si' : 'No' }}
            </span>
          </div>
        </div>

        <div
          *ngIf="technicalIssuesData?.accessControlCheck"
          class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('accessControl')"
            (change)="reviewFields.toggleField('accessControl')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Descripcion</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('accessControl')"
                class="-mt-2"
                [description]="previousReviewText('accessControl')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular whitespace-pre-line">
              {{ technicalIssuesData?.accessControl || '-' }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('attackProtectionCheck')"
            (change)="reviewFields.toggleField('attackProtectionCheck')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Proteccion contra ataques adversariales</span>
              <app-tooltip
                *ngIf="
                  reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('attackProtectionCheck')
                "
                class="-mt-2"
                [description]="previousReviewText('attackProtectionCheck')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular">
              {{ technicalIssuesData?.attackProtectionCheck ? 'Si' : 'No' }}
            </span>
          </div>
        </div>

        <div
          *ngIf="technicalIssuesData?.attackProtectionCheck"
          class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('attackProtection')"
            (change)="reviewFields.toggleField('attackProtection')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Descripcion</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('attackProtection')"
                class="-mt-2"
                [description]="previousReviewText('attackProtection')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular whitespace-pre-line">
              {{ technicalIssuesData?.attackProtection || '-' }}
            </span>
          </div>
        </div>

        <div
          *ngIf="technicalIssuesData?.csvAttackProtection"
          class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('csvAttackProtection')"
            (change)="reviewFields.toggleField('csvAttackProtection')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Codigo identificador del documento</span>
              <app-tooltip
                *ngIf="
                  reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('csvAttackProtection')
                "
                class="-mt-2"
                [description]="previousReviewText('csvAttackProtection')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular whitespace-pre-line">
              {{ technicalIssuesData?.csvAttackProtection || '-' }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('resilienceCheck')"
            (change)="reviewFields.toggleField('resilienceCheck')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Resiliencia frente a fallos</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('resilienceCheck')"
                class="-mt-2"
                [description]="previousReviewText('resilienceCheck')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular">
              {{ technicalIssuesData?.resilienceCheck ? 'Si' : 'No' }}
            </span>
          </div>
        </div>

        <div
          *ngIf="technicalIssuesData?.resilienceCheck"
          class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('resilience')"
            (change)="reviewFields.toggleField('resilience')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Descripcion</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('resilience')"
                class="-mt-2"
                [description]="previousReviewText('resilience')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular whitespace-pre-line">
              {{ technicalIssuesData?.resilience || '-' }}
            </span>
          </div>
        </div>

        <div
          *ngIf="technicalIssuesData?.csvResilience"
          class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('csvResilience')"
            (change)="reviewFields.toggleField('csvResilience')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Codigo identificador del documento</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('csvResilience')"
                class="-mt-2"
                [description]="previousReviewText('csvResilience')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-[16px] font-regular whitespace-pre-line">
              {{ technicalIssuesData?.csvResilience || '-' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
